import React, { useEffect } from "react";
import styles from "./Search.module.scss";
import { BiSearch } from "react-icons/bi";
import { useLocation, useNavigate } from "react-router";
import { useDispatch } from "react-redux";

const Search = ({ value, onChange }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

 
  return (
    <div className={styles.search}>
      <BiSearch size={18} className={styles.icon} />

      <input
        type="text"
        placeholder="Search by name"
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

export default Search;
